import keys from '@debbie/common/dist/cache/keys.js';
import { DocumentTypes } from '@debbie/common/dist/documents/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import * as documentsAPI from '@debbie/cortex/dist/api/documents.js';
import * as filesAPI from '@debbie/cortex/dist/api/files.js';
import { useFeeImages } from '@debbie/cortex/dist/bespoke/apcoa/fee-images.js';
import { documentsEntity } from '@debbie/cortex/dist/documents/index.js';
import { notifications } from '@debbie/cortex/dist/index.js';
import { useNewInteraction } from '@debbie/cortex/dist/newInteractions/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useCallback, useEffect, useState } from 'react';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import Button from '../../Button.js';
import ButtonGroup from '../../ButtonGroup.js';
import Errors from '../../Errors.js';
import { ArrowLeft, ArrowRight } from '../../Icons/index.js';
import Loading from '../../Loading.js';
import Modal from '../../Modal.js';
const Images = (props) => {
    const { caseVoucher } = props;
    const { images, status, error } = useFeeImages(caseVoucher.referenceId);
    const [previewImageIndex, setPreviewImageIndex] = useState(null);
    const loadingImages = status === 'loading';
    const previewImage = typeof previewImageIndex === 'number' ? images[previewImageIndex] : null;
    const previewOpen = previewImage != null && caseVoucher.caseId != null;
    const navigateImage = useCallback((direction) => {
        setPreviewImageIndex((index) => index == null || images.length === 0
            ? null
            : (index + direction + images.length) % images.length);
    }, [images.length]);
    useEffect(() => {
        if (!previewOpen) {
            return undefined;
        }
        const onKeyDown = (event) => {
            if (event.defaultPrevented ||
                (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) {
                return;
            }
            event.preventDefault();
            navigateImage(event.key === 'ArrowLeft' ? -1 : 1);
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [previewOpen, navigateImage]);
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Billeder"),
        React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '10px' } },
            images.map((image, i) => caseVoucher.caseId ? (React.createElement(Image, { key: image.fileName, image: image, caseId: caseVoucher.caseId, setPreviewIndex: () => setPreviewImageIndex(i) })) : null),
            loadingImages && React.createElement(ImageLoader, null),
            error != null && React.createElement(Errors, { errors: ['Error loading images'] }),
            previewImage && caseVoucher.caseId && (React.createElement(Modal, { maxWidth: "1000px", onToggle: () => setPreviewImageIndex(null), header: previewImage.fileName },
                React.createElement("p", { style: { textAlign: 'center' } },
                    React.createElement(ButtonGroup, null,
                        React.createElement(Button, { theme: "secondary", onClick: () => navigateImage(-1) },
                            React.createElement(ArrowLeft, null)),
                        React.createElement(Button, { theme: "secondary", onClick: () => navigateImage(1) },
                            React.createElement(ArrowRight, null)))),
                React.createElement("img", { width: "100%", style: {
                        maxHeight: 'calc(100vh - 200px)',
                        maxWidth: '100%',
                        objectFit: 'contain',
                    }, src: `data:${previewImage.contentType};base64, ${previewImage.content}`, alt: `Billede: ${previewImage.fileName}` }),
                React.createElement("p", { style: { textAlign: 'center' } },
                    React.createElement(AddToDocumentation, { image: previewImage, caseId: caseVoucher.caseId, style: {} }),
                    ' ',
                    React.createElement(AddToNewInteraction, { image: previewImage, caseId: caseVoucher.caseId, style: {} })))))));
};
const Image = (props) => {
    const { image } = props;
    return (React.createElement(ImageContainer, { onClick: () => props.setPreviewIndex() },
        React.createElement(AddToDocumentation, { image: image, caseId: props.caseId }),
        React.createElement(AddToNewInteraction, { image: image, caseId: props.caseId }),
        React.createElement("img", { src: `data:${image.contentType};base64, ${image.content}`, alt: `Billede: ${image.fileName}` })));
};
const ImageLoader = () => {
    return (React.createElement(LoaderContainer, null,
        React.createElement(Loading, { width: "30px" })));
};
const LoaderContainer = styled.div `
  background: ${THEME.FILL};
  border-radius: 5px;
  width: 264px;
  height: 264px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
const ImageContainer = styled.div `
  display: inline-block;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);

  width: 264px;
  height: 264px;

  button {
    opacity: 0;
  }

  &:hover {
    button {
      opacity: 1;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export default Images;
const AddToDocumentation = (props) => {
    const { image } = props;
    const [loadingAddToDocumentation, setLoadingAddToDocumentation] = useState(false);
    const [added, setAdded] = useState(false);
    const addToDocuments = async () => {
        try {
            setLoadingAddToDocumentation(true);
            const newFile = await filesAPI.save({
                content: image.content,
                name: image.fileName,
                contentType: image.contentType,
            });
            await documentsAPI.add(props.caseId, DocumentTypes.OTHER, Entity.Case, newFile.file, false, undefined, undefined, 'debtor');
            notifications.notification({
                title: 'Billedet er tilføjet til dokumentation',
            });
            q.invalidate(keys.write.create(documentsEntity));
            setAdded(true);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoadingAddToDocumentation(false);
    };
    return (React.createElement(Button, { style: props.style
            ? props.style
            : {
                position: 'absolute',
                bottom: '60px',
                left: '10px',
                right: '10px',
            }, size: "small", theme: "secondary", onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            addToDocuments();
        }, loading: loadingAddToDocumentation, disabled: added }, "Tilf\u00F8j til dokumentation"));
};
const AddToNewInteraction = (props) => {
    const { image } = props;
    const [interaction, setInteraction] = useNewInteraction(props.caseId);
    const uploadedFiles = interaction.uploadedFiles;
    const [added, setAdded] = useState(false);
    const [loadingAddToInteraction, setLoadingAddToInteraction] = useState(false);
    const addToNewInteraction = async () => {
        try {
            setLoadingAddToInteraction(true);
            const newFile = await filesAPI.save({
                content: image.content,
                name: image.fileName,
                contentType: image.contentType,
            });
            setInteraction('uploadedFiles', [...uploadedFiles, newFile.file]);
            notifications.notification({
                title: 'Billedet er tilføjet til interaktioner',
            });
            setAdded(true);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoadingAddToInteraction(false);
    };
    return (React.createElement(Button, { style: props.style
            ? props.style
            : {
                position: 'absolute',
                bottom: '10px',
                left: '10px',
                right: '10px',
            }, size: "small", theme: "secondary", onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            addToNewInteraction();
        }, loading: loadingAddToInteraction, disabled: added }, "Tilf\u00F8j til interaktion (email, note...)"));
};
//# sourceMappingURL=FeeImages.js.map